<div class="chat-button" *ngIf="data?.show_chat" [ngClass]="{'off': headerOpen || hideChat}" (click)="openChat()">
    <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 35">
            <path
                d="M19.5 0C8.73 0 0 7.84 0 17.5a15.76 15.76 0 00.27 2.77L0 20a6.14 6.14 0 01.35.65 15.55 15.55 0 00.87 2.94A16.53 16.53 0 010 32.5h9.47a21.11 21.11 0 0010 2.5C30.27 35 39 27.16 39 17.5S30.27 0 19.5 0zm3.15 23.13H10.06v-1.25h12.59zm6.29-4.38H10.06V17.5h18.88zm0-4.38H10.06v-1.25h18.88z" />
        </svg>
    </div>
    <p [innerHTML]="data?.chat_text"></p>
</div>
